// extracted by mini-css-extract-plugin
module.exports = {"container":"AccreditedToggle_container__1b1x_","item":"AccreditedToggle_item__fD5Eg","active":"AccreditedToggle_active__DN6td"};